export const formatCombatActionError = (result, fallback = 'Action execution failed') => {
  const primary = String(result?.error || result?.reason || '').trim();
  const details = Array.isArray(result?.errors)
    ? result.errors.map((entry) => String(entry || '').trim()).filter(Boolean)
    : [];

  if (details.length === 0) return primary || fallback;
  if (!primary || /^handler validation failed$/i.test(primary)) return details.join('; ');
  return `${primary}: ${details.join('; ')}`;
};

export const buildCombatActionFailureFeedback = (result, context = {}) => {
  const actionName = String(context.actionName || 'Action').trim();
  const targetName = String(context.targetName || 'That target').trim();
  const range = String(context.range || '').trim();
  const details = Array.isArray(result?.errors)
    ? result.errors.map((entry) => String(entry || '').trim()).filter(Boolean)
    : [];
  const rangeError = details.find((entry) => /out of range|out of .*reach/i.test(entry));

  if (rangeError) {
    const detail = rangeError
      .replace(/^Target\s+.+?\s+out of range:\s*/i, '')
      .replace(/^Target\s+out of range:?\s*/i, '')
      .trim();
    const rangeLabel = range ? ` (Range: ${range})` : '';
    return {
      disposition: 'retarget',
      title: 'Target out of range',
      message: `${targetName} is out of range for ${actionName}${rangeLabel}.${detail ? ` ${detail}.` : ''} Move closer or select another target.`
    };
  }

  return {
    disposition: 'retry',
    title: context.title || 'Action failed',
    message: `${actionName}: ${formatCombatActionError(result, context.fallback || 'Action execution failed')}`
  };
};

